import { generatePath } from 'react-router-dom'
import {
  ADD_CART_ITEM,
  REMOVE_CART_ITEM,
  UPDATE_CART_ITEM,
  CONFIRM_OUT_OF_STOCK,
} from 'constants/api-paths'
import request from './request'
import { formatError } from './error'

export const requestAddCartItem = async (id, params) => {
  const path = generatePath(ADD_CART_ITEM, { id })

  return request.post(path, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}

export const requestRemoveCartItem = async ({ orderId, itemId }) => {
  const path = generatePath(REMOVE_CART_ITEM, { orderId, itemId })

  return request.delete(path)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}

export const requestUpdateCartItem = async ({ orderId, itemId, params }) => {
  const path = generatePath(UPDATE_CART_ITEM, { orderId, itemId })

  return request.patch(path, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}

export const requestConfirmOutOfStock = async ({ orderId, itemId }) => {
  const path = generatePath(CONFIRM_OUT_OF_STOCK, { orderId, itemId })

  return request.patch(path)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}
